import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import styles from './TabContentWrapper.module.scss';

// istanbul ignore next
const useIsomorphicEffect = () => {
    /* eslint-disable-next-line no-undef */
    const isNode = typeof process === 'object' && process.versions && !!process.versions.node;
    return isNode ? React.useEffect : React.useLayoutEffect;
};

const TabContentWrapper = ({ tab, items, click }) => {
    const wrapperRef = React.useRef(null);
    const firstUpdate = React.useRef(true);
    const isomorphicEffect = useIsomorphicEffect();

    const handleClick = (tab) => click && click(tab);

    isomorphicEffect(() => {
        /* istanbul ignore next */
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        /* istanbul ignore next */
        /* eslint-disable-next-line no-undef */
        window.scroll({
            /* eslint-disable-next-line no-undef */
            top: wrapperRef.current.getBoundingClientRect().top + window.scrollY - 180,
            behavior: 'smooth',
        });
    }, [tab]);

    return (
        <div ref={wrapperRef} className={styles['tab-content-wrapper-component']}>
            {(items || []).map((item) =>
                item ? (
                    <Fragment key={item.id}>
                        <button
                            onClick={() => handleClick(item.id)}
                            className={`${styles['tab-header']}${
                                item.id === tab ? `` : ` ${styles['collapsed']}`
                            }`}
                        >
                            {item.title}
                        </button>
                        <div
                            className={`${styles['tab-body']} ${
                                item.id === tab ? `` : ` ${styles['collapsed']}`
                            }`}
                        >
                            {item.content}
                        </div>
                    </Fragment>
                ) : null,
            )}
        </div>
    );
};

TabContentWrapper.propTypes = {
    tab: PropTypes.number,
    click: PropTypes.func,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
            content: PropTypes.element,
        }),
    ),
};

export default TabContentWrapper;
